import { useGetCurrentUserQuery } from '../api/user.api.ts';
import { type PermissionLevel, type RoleName, type RoleScope } from '../api/models/user.model.ts';

export function useIsUserInternal() {
	const { data: user } = useGetCurrentUserQuery();
	const internalRole =
		!!user &&
		user.roles &&
		user.roles.length > 0 &&
		user.roles.some((role) => role.roleType === 'INTERNAL_USER');

	return !!internalRole;
}

export function useUserHasRoleName(roleName?: RoleName) {
	const { data: user } = useGetCurrentUserQuery();
	return Boolean(user?.roles && roleName && user.roles.some((role) => role.roleName === roleName));
}

/**
 * Checks if the user has any of the supplied permissionLevels on any of their roles.
 * @returns `false` if either `user` or `permissionLevels` are undefined
 * @deprecated in favor of checking against roleScope
 */
export function useUserHasSomeOfPermissionLevel(permissionLevels?: PermissionLevel[]) {
	const { data: user } = useGetCurrentUserQuery();
	return Boolean(
		user?.roles &&
		permissionLevels &&
		user.roles.some((role) => permissionLevels.includes(role.permissionLevel))
	);
}

/**
 * Checks if the user has the supplied roleScope on any of their roles.
 * @returns `false` if either `user` or `roleScope` are undefined  
 */
export function useUserHasRoleScope(roleScope?: RoleScope) {
	const { data: user } = useGetCurrentUserQuery();
	return Boolean(
		user?.roles && roleScope && user.roles.some((role) => role.roleScopes.includes(roleScope))
	);
}
